import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PreviewDataOptions } from './preview-data.interface';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'preview-data',
  templateUrl: './preview-data.component.html',
  styleUrls: ['./preview-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class PreviewDataComponent implements OnInit, OnChanges {
  @Input() drawerOpen: boolean = false;
  @Input() module: string = '';
  @Input() moduleUID: string = '';
  @Input() options: PreviewDataOptions = {
    position: '',
    type: '',
    mode: '',
    hasBackDrop: false
  };
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() previewDrawerName: string = ''; //We can set unqiue name for preview data drawer

  drawerName: string = 'previewData';
  emitValue: any = null;

  constructor(
    private zuperDrawerService: ZuperDrawerService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.drawerName = this.previewDrawerName || this.drawerName;
    this.drawerName = this.drawerName + uuidv4();
    this.changeDetectorRef.markForCheck();
  }

  drawerOpenedChanged(isOpened: boolean): void {
    if (!isOpened) {
      let emitterValue: any = {
        drawerClosed: true
      };
      if (this.emitValue && Object.keys(this.emitValue)?.length) {
        emitterValue = { ...emitterValue, ...this.emitValue };
        this.changeDetectorRef.markForCheck();
      }
      this.eventEmitter.emit(emitterValue);
      this.changeDetectorRef.markForCheck();
    } else {
      this.emitValue = null;
      this.changeDetectorRef.markForCheck();
    }
  }

  eventEmitHandler(event: any): void {
    if (event.drawerClose) {
      delete event.drawerClose;
      this.emitValue = event;
      this.toggleDrawer(false);
      this.changeDetectorRef.markForCheck();
    }
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer.open() : drawer.close();
    this.changeDetectorRef.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.drawerOpen?.previousValue !== undefined) {
      this.toggleDrawer(changes?.drawerOpen.currentValue);
      this.changeDetectorRef.markForCheck();
    }
  }
}
